import { Card, Table, Heading, Box, Badge } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import { AudioLayoutConfig } from '../types';

interface ClipAudioLayoutCardProps {
    layouts?: AudioLayoutConfig[];
}

export const ClipAudioLayoutCard = ({ layouts }: ClipAudioLayoutCardProps) => {
    const { t } = useTranslation('clipDetails');

    if (!layouts || layouts.length === 0) return null;

    return (
        <Card size='1' variant='surface'>
            <Box mb='4'>
                <Heading
                    size='3'
                    as='h3'
                    weight='bold'
                    style={{ color: 'var(--gray-12)' }}
                >
                    {t('audio_layout.title')}
                </Heading>
            </Box>

            <Table.Root variant='surface' size='2'>
                <Table.Header>
                    <Table.Row>
                        <Table.ColumnHeaderCell>
                            {t('audio_layout.mapping')}
                        </Table.ColumnHeaderCell>
                        <Table.ColumnHeaderCell>
                            {t('audio_layout.label')}
                        </Table.ColumnHeaderCell>
                        <Table.ColumnHeaderCell>
                            {t('audio_layout.mix')}
                        </Table.ColumnHeaderCell>
                        <Table.ColumnHeaderCell>
                            {t('audio_layout.language')}
                        </Table.ColumnHeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {layouts.map((layout, index) => (
                        <Table.Row key={index} align='center'>
                            <Table.RowHeaderCell>
                                <Badge color='gray' variant='soft' highContrast>
                                    {layout.mapping}
                                </Badge>
                            </Table.RowHeaderCell>
                            <Table.Cell style={{ color: 'var(--gray-11)' }}>
                                {layout.label || '-'}
                            </Table.Cell>
                            <Table.Cell style={{ color: 'var(--gray-12)' }}>
                                {layout.mix || '-'}
                            </Table.Cell>
                            <Table.Cell style={{ color: 'var(--gray-12)' }}>
                                {layout.language || '-'}
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table.Root>
        </Card>
    );
};
